import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `
header {
  background-color: ${dt('appHeader.background')};
}

.environment {
  font-weight: 600;

  &[data-env="localhost"] {
    color: ${dt('surface.200')};
  }

  &[data-env="development"] {
    color: ${dt('green.600')};
  }

  &[data-env="testing"] {
    color: ${dt('yellow.400')};
  }
}

.logo-button {
  background: transparent;
  border: 0;
  padding: 0;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
}

@keyframes logo-dance {
  0%, 100% { transform: rotate(0) scale(1); }
  15% { transform: rotate(-15deg) scale(1.1); }
  30% { transform: rotate(12deg) scale(1.15); }
  45% { transform: rotate(-10deg) scale(1.15); }
  60% { transform: rotate(10deg) scale(1.1); }
  75% { transform: rotate(-6deg) scale(1.05); }
  90% { transform: rotate(4deg) scale(1.02); }
}

.logo-dance {
  animation: logo-dance 1.5s ease-in-out;
  transform-origin: center;
}

@media (prefers-reduced-motion: reduce) {
  .logo-dance {
    animation: none;
  }
}
`;
